import { useEffect, useState } from 'react';
import { errorText, isApiMissing } from './constants';

/**
 * Runs `request` (a function returning an axios promise) whenever `key` changes; `skip` holds it back.
 * `missing` is true when the endpoint is not there or not open to merchants yet (see isApiMissing), so the
 * page can show the API-needed notice instead of a generic error.
 */
export default function usePtlApi(request, key, { skip = false } = {}) {
  const [state, setState] = useState({ data: null, loading: !skip, error: null, missing: false });

  useEffect(() => {
    if (skip) return undefined;
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    request()
      .then((res) => { if (alive) setState({ data: res?.data ?? null, loading: false, error: null, missing: false }); })
      .catch((e) => {
        if (!alive) return;
        setState({ data: null, loading: false, error: errorText(e), missing: isApiMissing(e) });
      });
    return () => { alive = false; };
    // `key` stands for everything the request depends on.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, skip]);

  return state;
}
